module.exports = __webpack_public_path__ + "img/activity_tab_img.f754b840.png";